import * as React from 'react';
import { TopToolbar, ListButton } from 'react-admin';

const TemplateCreateActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);
export default TemplateCreateActions;
